import Vue from 'vue';
import formatDate from 'date-fns/format';
import { removeUser } from '../services/auth';
import router from '../router';
import store from '../store';

export async function handleNetworkError(error, fallbackMessage = "Network error"){
  if(error.response && error.response.status && error.response.status === 401){
    await removeUser();
    store.dispatch('setAuthUser', null);
    router.replace('/login');
  }

  if(error && error.response && error.response.data
    && (error.response.data.userMessage || error.response.data.developerMessage)){
    if(!error.response.data.userMessage)
      console.log("Error: ", error.response.data.developerMessage);
    else if(error.response.data.userMessage === "Whoops! Something went wrong.")
      showErrorToast(error.response.data.developerMessage);
    else
      showErrorToast(error.response.data.userMessage);

    if(error.response.data.developerMessage){
      const errorMessage = error.response.data.developerMessage;

      if(errorMessage == "Your account is not approved")
        router.replace('/not-verified');
      else if(errorMessage == "Your role is not approved")
        router.replace('/role-not-approved');
    }
  }
  else
    console.log(fallbackMessage, error);
}

export function showErrorToast(message){
  Vue.$toast.error(message, {
    position: 'top-right',
    duration: 3000
  });
}

export function showSuccessToast(message){
  Vue.$toast.success(message, {
    position: 'top-right',
    duration: 3000
  });
}

export function makePhoneNumberValid(unformattedNumber){
  // remove (, ), - and spaces
  let number = unformattedNumber.replace(/-|\(|\)|\s/g, "");
  if(number.charAt(0) === "0" || number.charAt(0) === "+")
    number = number.substring(1);

  if(number.substring(0, 3) === "255")
    number = number.substring(3);

  return "+255" + number;
}

export function someTime(time = 10){
  return new Promise((resolve) => setTimeout(() => resolve(), time));
}

export function getScheduleRepeatString(scheduleObject){
  let repeatString = "Never";
  if(scheduleObject.mode !== "repeat"){
    if(scheduleObject.date){
      repeatString = "Once, " + formatDate(new Date(scheduleObject.date), "MMMM Do YYYY");
    }
  }
  else{
    const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    
    if(scheduleObject.dayOfMonth !== undefined && scheduleObject.dayOfMonth !== null){
      const date = formatDate(new Date(`${scheduleObject.dayOfMonth} December 2020`), 'Do');
      repeatString = "Monthly on the " + date;
    }
      
    else if(scheduleObject.dayOfWeek !== undefined && scheduleObject.dayOfWeek !== null)
      repeatString = "Weekly on " + weekDays[scheduleObject.dayOfWeek];
      
    else if(scheduleObject.hour !== undefined && scheduleObject.hour !== null){
      repeatString = "Daily at ";
      let hour = scheduleObject.hour;

      if(hour === 0 || hour == 12)
        repeatString += hour ? "noon" : "midnight";
      else{
        repeatString += hour % 12;
        repeatString += hour > 12 ? " pm" : " am";
      }
    }
  }

  return repeatString;
}
